import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import { PushNotification } from '../../types';

interface NotificationState {
  notifications: PushNotification[];
  unreadCount: number;
  permission: NotificationPermission;
}

const initialState: NotificationState = {
  notifications: [],
  unreadCount: 0,
  permission: 'default'
};

const notificationSlice = createSlice({
  name: 'notification',
  initialState,
  reducers: {
    addNotification: (state, action: PayloadAction<PushNotification>) => {
      const MAX_NOTIFICATIONS = 100; // Limit notifications to prevent memory leaks
      
      state.notifications.unshift(action.payload);
      // Keep only the last MAX_NOTIFICATIONS
      if (state.notifications.length > MAX_NOTIFICATIONS) {
        state.notifications = state.notifications.slice(0, MAX_NOTIFICATIONS);
      }
      if (!action.payload.readAt) {
        state.unreadCount++;
      }
    },
    markNotificationRead: (state, action: PayloadAction<string>) => {
      const notification = state.notifications.find(n => n.id === action.payload);
      if (notification && !notification.readAt) {
        notification.readAt = new Date();
        state.unreadCount = Math.max(0, state.unreadCount - 1);
      }
    },
    markAllRead: (state) => {
      state.notifications.forEach(n => {
        if (!n.readAt) {
          n.readAt = new Date();
        }
      });
      state.unreadCount = 0;
    },
    clearNotifications: (state) => {
      state.notifications = [];
      state.unreadCount = 0;
    },
    setPermission: (state, action: PayloadAction<NotificationPermission>) => {
      state.permission = action.payload;
    }
  }
});

export const {
  addNotification,
  markNotificationRead,
  markAllRead,
  clearNotifications,
  setPermission
} = notificationSlice.actions;

export default notificationSlice.reducer;